import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';
import { Container } from 'styles';

// TODO: move to shrike
export const Tip = styled(Container).attrs({
  flex: true,
  margin: { bottom: '40px' },
})<StyleProps>`
  background-color: ${props => props.theme.colors.background.accent2};
  border-radius: ${props => props.theme.borderRadii.small};
  width: 100%;
  padding: 16px;
`;

export const StyledText = styled(Text)`
  font-style: italic;
`;
